module.exports = __webpack_public_path__ + "static/img/icon1.a3a0b505.png";